module.exports = __webpack_public_path__ + "img/5.785edf4c.png";